import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { authStatusSelector, authTokenSelector } from "../services/redux/slices/authSlice";
import { useDispatch } from "react-redux";
import { initializeFromSessionStorage } from "../services/redux/slices/authSlice";

export const useAuth = () => {
  const dispatch = useDispatch();
  const authStatus = useSelector(authStatusSelector);
  const token = useSelector(authTokenSelector);
  const [isInitialized, setIsInitialized] = useState(false);

  useEffect(() => {
    // Initialize from sessionStorage if Redux persist hasn't loaded yet
    if (!token && !isInitialized) {
      dispatch(initializeFromSessionStorage());
    }
    
    // Mark as initialized after Redux persist has had time to rehydrate
    const timer = setTimeout(() => {
      setIsInitialized(true);
    }, 500); // Increased timeout to allow Redux persist to rehydrate
    
    return () => clearTimeout(timer);
  }, [dispatch, token, isInitialized]);

  // Use Redux state as primary source of truth
  const isAuthenticated = authStatus && !!token;

  return {
    isAuthenticated,
    isInitialized,
    authStatus,
    token,
  };
};
